const PHASES = [
  {
    id: "coach-setup",
    number: 1,
    title: "Coach Setup",
    tagline: "Set Up Your Coaching Business in Minutes",
    color: "#2E5266",
    audio: "/audio/phase-1-coach-setup.mp3",
    steps: [
      { number: 1, title: "Create Organization", description: "Sign up and create your coaching business. Set up your profile, brand, and preferences.", appRoutes: [], clientSide: false },
      { number: 2, title: "Define Training Plans", description: "Build reusable and client-specific training plans with version drafts, publish rollout, and version comparison.", appRoutes: ["/home/training-plans-v2/library", "/home/protocols"], clientSide: false },
      { number: 3, title: "Create Meal Plans", description: "Design nutrition plans manually or use AI to generate personalized meal plans.", appRoutes: ["/home/recipes", "/home/meal-plans"], clientSide: false },
      { number: 4, title: "Add Clients", description: "Create client profiles with auto-generated connect codes for seamless onboarding.", appRoutes: ["/home/clients"], clientSide: false },
      { number: 5, title: "Send Invites", description: "Share unique connect codes via shareable link, email, or text message.", appRoutes: ["/home/clients"], clientSide: false },
    ],
  },
  {
    id: "client-onboarding",
    number: 2,
    title: "Client Onboarding",
    tagline: "Seamless Client Onboarding",
    color: "#FF7A5A",
    audio: "/audio/phase-2-client-onboarding.mp3",
    steps: [
      { number: 6, title: "Download the App", description: "Clients install the Mighty45 app from iOS App Store or Google Play.", appRoutes: [], clientSide: true },
      { number: 7, title: "Sign Up with Code", description: "The connect code automatically links clients to your organization.", appRoutes: [], clientSide: true },
      { number: 8, title: "Complete Onboarding", description: "Clients fill out their profile, goals, and initial assessment.", appRoutes: [], clientSide: true },
    ],
  },
  {
    id: "active-coaching",
    number: 3,
    title: "Active Coaching",
    tagline: "Deliver World-Class Coaching, Every Day",
    color: "#10B981",
    audio: "/audio/phase-3-active-coaching.mp3",
    isRecurring: true,
    steps: [
      { number: 9, title: "Receive Plans", description: "Assign training and meal plans. Clients get instant notifications.", appRoutes: ["/home/clients"], clientSide: false },
      { number: 10, title: "Daily Check-ins", description: "Clients log weight, macros, water intake, and steps.", appRoutes: [], clientSide: true, badge: "Optional" },
      { number: 11, title: "Complete Workouts", description: "Clients track exercises, sets, reps, and weights throughout the week.", appRoutes: [], clientSide: true },
      { number: 12, title: "Real-time Messaging", description: "Communicate via text, voice messages, images, and file sharing.", appRoutes: ["/home/messages"], clientSide: false },
      { number: 13, title: "Progress Photos", description: "Clients submit photos with AI-powered evaluation and analysis.", appRoutes: [], clientSide: true, badge: "AI-Powered" },
    ],
  },
  {
    id: "weekly-review",
    number: 4,
    title: "Weekly Review",
    tagline: "Data-Driven Progress Reviews",
    color: "#6366F1",
    audio: "/audio/phase-4-weekly-review.mp3",
    steps: [
      { number: 14, title: "Submit Weekly Report", description: "Clients submit their comprehensive end-of-week report.", appRoutes: [], clientSide: true },
      { number: 15, title: "Data Aggregation", description: "Report automatically compiles all health, exercise, and photo data.", appRoutes: [], clientSide: false, automatic: true },
      { number: 16, title: "Coach Receives Report", description: "Reports appear in your FIFO queue, oldest first.", appRoutes: ["/home/reports"], clientSide: false },
      { number: 17, title: "Review & Feedback", description: "Review detailed reports with compliance scoring. Provide feedback via chat. Use Client progress over time from the client summary or dashboard for long-range trends.", appRoutes: ["/home/reports", "/home/clients/progress"], clientSide: false },
      { number: 18, title: "Plan Adjustments", description: "Create a new plan version draft, test changes safely, then publish to roll updates to assigned clients with notifications.", appRoutes: ["/home/training-plans-v2/library", "/home/clients", "/home/protocols"], clientSide: false, isCycleEnd: true },
    ],
  },
];

export default PHASES;
